
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.363 1.155H7.646c-.775 0-1.53.245-2.156.7L3.292 3.454a3.668 3.668 0 00-1.333 1.834L1.12 7.87c-.239.737-.239 1.53 0 2.267l.84 2.584c.24.737.706 1.38 1.333 1.834l2.198 1.598c.627.455 1.381.7 2.156.7h2.717c.775 0 1.53-.245 2.156-.7l2.198-1.598a3.668 3.668 0 001.333-1.834l.84-2.584c.24-.737.24-1.53 0-2.267l-.84-2.584a3.668 3.668 0 00-1.333-1.834L12.52 1.856a3.668 3.668 0 00-2.156-.7z","fill":"url(#paint0_radial_8512_25404)","stroke":"#4A2D00","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6.654 6.45a.104.104 0 11-.104-.104M10.82 5.617a.104.104 0 11-.103-.104M12.488 8.95a.104.104 0 11-.105-.104M9.154 8.95a.104.104 0 11-.104-.104M5.82 10.617a.104.104 0 11-.103-.105M9.988 12.283a.104.104 0 11-.105-.104","stroke":"#221600","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('defs',[_c('radialGradient',{attrs:{"id":"paint0_radial_8512_25404","cx":"0","cy":"0","r":"1","gradientUnits":"userSpaceOnUse","gradientTransform":"matrix(0 5.87464 -6.03568 0 9.005 9.38)"}},[_c('stop',{attrs:{"offset":".432","stop-color":"#FFD178"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFAC0B"}})])])])
          )
        }
      }
    